import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=7cfcd7a7&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ISecure: require('/opt/build/repo/components/svg/Secure.vue').default,IBike: require('/opt/build/repo/components/svg/Bike.vue').default,IClickNCollect: require('/opt/build/repo/components/svg/ClickNCollect.vue').default,IEar: require('/opt/build/repo/components/svg/Ear.vue').default,SocialLinks: require('/opt/build/repo/components/SocialLinks.vue').default,ILogoRound: require('/opt/build/repo/components/svg/LogoRound.vue').default})
